import script from "./FilterableMenus.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterableMenus.vue?vue&type=script&setup=true&lang=js"

import "./FilterableMenus.vue?vue&type=style&index=0&id=8e785d7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e785d7a"]])

export default __exports__